"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

var SzTooltip_1 = __importDefault(require("../SzTooltip/SzTooltip"));

require("./SzInput.scss");

var SzInput = react_1.default.forwardRef(function (props, ref) {
  var autocomplete = props.autocomplete,
      className = props.className,
      error = props.error,
      icon = props.icon,
      id = props.id,
      info = props.info,
      label = props.label,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onPaste = props.onPaste,
      onKeyUp = props.onKeyUp,
      handleClear = props.handleClear,
      name = props.name,
      placeholder = props.placeholder,
      required = props.required,
      type = props.type,
      valid = props.valid,
      showPassword = props.showPassword,
      value = props.value;

  var showPass = function showPass() {
    return type === 'password' ? 'text' : 'password';
  };

  var formClasses = classnames_1.default('sz-form-group', className);
  var labelClasses = classnames_1.default('sz-label-input position-relative d-block', {
    required: required
  });
  var inputClasses = classnames_1.default('sz-form-group__sz-input-text font-family-bold pl-3', value.length > 0 ? 'bg-white' : 'bg-light', {
    'sz-form-group__sz-input-text--icon pl-5': icon,
    'sz-form-group__sz-input-text--error': value.length > 0 && error,
    'sz-form-group__sz-input-text--checked': value.length > 0 && !error
  });
  return react_1.default.createElement("div", {
    className: formClasses
  }, label && react_1.default.createElement("label", {
    className: labelClasses
  }, label), react_1.default.createElement(react_bootstrap_1.InputGroup, {
    className: "mb-3"
  }, handleClear && value.length > 0 && react_1.default.createElement("span", {
    className: "sz-form-group__input-group-icon-clear position-absolute d-flex align-items-center justify-content-center",
    onClick: handleClear
  }, react_1.default.createElement(SzIcon_1.default, {
    icon: "remove",
    variant: "bold",
    className: "normal"
  })), react_1.default.createElement(react_bootstrap_1.FormControl, {
    autoComplete: "" + autocomplete,
    ref: ref,
    id: id,
    value: value,
    placeholder: placeholder,
    type: type,
    className: inputClasses,
    onChange: onChange,
    onKeyUp: onKeyUp,
    onPaste: onPaste,
    onBlur: onBlur,
    name: name
  }), showPassword && react_1.default.createElement("span", {
    className: "sz-form-group__input-group-icon-valid position-absolute d-flex align-items-center justify-content-center"
  }, react_1.default.createElement(SzIcon_1.default, {
    icon: type === 'password' ? 'view-1' : 'view-off',
    onClick: showPass,
    variant: "bold"
  })), icon && react_1.default.createElement(react_bootstrap_1.InputGroup.Prepend, {
    className: "sz-form-group__input-group-icon position-absolute d-flex align-items-center justify-content-center text-primary"
  }, icon), valid && react_1.default.createElement("span", {
    className: "sz-form-group__input-group-icon-valid position-absolute bg-secondary d-flex align-items-center justify-content-center text-white font-weight-bold"
  }, react_1.default.createElement(SzIcon_1.default, {
    variant: "bold",
    icon: "check"
  })), info && value.length === 0 && react_1.default.createElement("div", {
    className: "sz-form-group__input-group-icon-info position-absolute d-flex align-items-center justify-content-center bg-light text-secondary"
  }, react_1.default.createElement(SzTooltip_1.default, {
    content: "info"
  }, react_1.default.createElement(SzIcon_1.default, {
    icon: "information-circle",
    variant: "bold",
    className: "normal"
  })))));
});
exports.default = SzInput;
SzInput.propTypes = {
  required: prop_types_1.default.bool,
  type: prop_types_1.default.oneOf(['text', 'email', 'password']),
  placeholder: prop_types_1.default.string,
  id: prop_types_1.default.string,
  className: prop_types_1.default.string,
  autocomplete: prop_types_1.default.bool,
  showPassword: prop_types_1.default.bool,
  onChange: prop_types_1.default.func,
  onKeyUp: prop_types_1.default.func,
  onPaste: prop_types_1.default.func,
  onBlur: prop_types_1.default.func
};
SzInput.defaultProps = {
  required: false,
  placeholder: false,
  type: 'text',
  value: '',
  name: null,
  autocomplete: true,
  showPassword: false
};